export interface ReferralFormData {
  timezone: string;
  user_agent: string;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  postal_code: string;
  verification_type?: string;
  interests: string[];
  tax_intents: string[];
  tax_questions: string;
  tax_advice: string[];
  tax_history: string;
  tax_confidence: string;
  importance: string;
  leadSource: string;
  tax_situation: string;
  purpose: string;
  ph_personal_intents?: string[];
  ph_self_employed_small_business_intent?: string[];
  ph_tax_issues?: string[];
  ph_tax_advice?: string[];
  ph_something_else?: string;
  ph_urgency?: string;
  tax_business_intents?: string[];
  tax_personal_intents?: string[];
  tell_us_more?: string;
}

export function initialReferralForm(): ReferralFormData {
  return {
    timezone: '',
    user_agent: '',
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    postal_code: '',
    interests: [],
    tax_intents: [],
    tax_questions: '',
    tax_advice: [],
    tax_history: '',
    tax_confidence: '',
    importance: '',
    leadSource: '',
    tax_situation: '',
    purpose: ''
  };
}
